<template>
    <div class="home">

        <div class="menuButtons">
            <MenuButton  :icons="[require('../assets/img/园区概况1.png'),require('../assets/img/园区概况2.png'),]" title="园区概况" 
            @click="menu === 1 ? menu = -1 : menu = 1" @on="sendMessage('parkOverview','park')" @off="sendMessage('clearParkOverview')"
            :selected="menu === 1"/>

            <MenuButton  :icons="[require('../assets/img/站点分布1.png'),require('../assets/img/站点分布2.png'),]" title="站点分布" 
            @click="menu === 2 ? menu = -1 : menu = 2" @on="sendMessage('siteOverview','site')" @off="sendMessage('clearSiteOverview')"
            :selected="menu === 2"/>

            <MenuButton  :icons="[require('../assets/img/供配线缆1.png'),require('../assets/img/供配线缆3.png'),]" title="供配线缆" 
            @click="menu === 3 ? menu = -1 : menu = 3" @on="sendMessage('electricLine')" @off="sendMessage('clearElectricLine')"
            :selected="menu === 3" v-show="$store.state.currentPage != 3"/>

            <MenuButton  :icons="[require('../assets/img/接线图1.png'),require('../assets/img/接线图2.png'),]" title="接线图" 
            @click="isshowDiagram = !isshowDiagram"  @on="Diagram()" @off="Diagram1"
            :selected="isshowDiagram" v-show="$store.state.currentPage != 3"/>

            
        </div>
        
        <!-- 接线图 -->
        <ViewDiagram  @showDiagram="showDiagram" v-show="isshowDiagram"/>

        <!-- 总览 -->
        <!-- <ParkOverView :projectId="$store.state.projectId" />         -->
        <Transformer v-if="$store.state.currentPage == 1 || $store.state.currentPage == 2"/>
        <!-- 发电总功率 -->
        <Power v-if="$store.state.currentPage == 1 || $store.state.currentPage == 3"/>
        <Electricity v-if="$store.state.currentPage == 1" @showElectricity="showElectricity"/>
        <Monitor v-if="$store.state.currentPage == 1 || $store.state.currentPage == 2" />
        <!-- <MonitorYSY v-if="$store.state.currentPage == 1 || $store.state.currentPage == 2"/> -->
        <Events @showAlarmPosition="showAlarmPositionBy"/>

        <!-- 变配电 -->
        <Diagram v-if="$store.state.currentPage == 2" :areaId="-1"/>  
        <SitElectricity v-show="$store.state.currentPage == 2"/>

        <!-- 微电网 -->
        <!-- 发电统计 -->
        <PowerGeneration v-if="$store.state.currentPage == 3"/>
        <Soc v-if="$store.state.currentPage == 3"/>
        <Environmental v-if="$store.state.currentPage == 3"/>

        <!-- <transition name="alarm" >
            <div  :class="item.type ==1? 'posAlarm':item.type ==2? 'posAlarm yellowAlarm':'posAlarm blueAlarm'" v-show="alarmState" v-for="item in eventsList" :key="item.id">
                <div class="alarmEvents">
                    <div class="alarmEvent"  >
                        <div class="atop">
                            <div class="img"></div>
                            <div class="eventName">
                                {{item.ename}}
                            </div>
                            <span>{{item.etime}}</span>
                            <img src="@/assets/img/关闭.png" alt="" @click="alarmState = !alarmState">
                        </div>
                        <div class="abottom">
                            <div class="con">
                                {{item.eloop }}
                            </div>
                            <img src="@/assets/img/position1.png" alt="" @click="showAlarmPositionBy(item)" style="cursor: pointer;">
                        </div>
                    </div>
                </div>
            </div>
        </transition> -->

        <!-- 报警 -->
        <div class="posAlarms" v-show="$store.state.showAlarm" >
            <div class="alarmEventss">
                <div class="alarmEvents" v-for="item in eventsListt" :key="item.id">
                    <div class="atops">
                        <img :src="item.src" alt="">
                        {{item.ename}}
                        <span>{{item.etime}}</span>
                    </div>
                    <div class="abottoms">
                        <div class="cons">
                            {{item.eloop }}
                        </div>
                        <img src="@/assets/img/position1.png" alt="" @click="showAlarmPositionBy(item)" style="cursor: pointer;">
                    </div>
                </div>
                <div class="noneEvent" v-show="eventsListt.length == 0">暂无报警</div>
            </div>
        </div>


        <!-- <iframe name="GIS" frameborder="0" width="100%" height="100%" ref="iframeDom" :src=" url + $store.state.gisUrl" allowfullscreen="true">
        </iframe>    -->
 

        <!-- <iframe name="GIS" frameborder="0" width="100%" height="100%" ref="iframeDom" src="http://127.0.0.1:5502/Apps/Sandcastle/gallery/changhua_web.html">
        </iframe> -->

        <iframe name="GIS" frameborder="0" width="100%" height="100%" ref="iframeDom" src="https://www.energydt.cn:18182/Apps/Sandcastle/gallery/changhua_web.html">
        </iframe>

        
    </div>
</template>

<script>
    const ParkOverView = () => import("./components/ParkOverView")
    const Transformer = () => import("./components/Transformer")
    const Power = () => import("./components/Power")
    const Electricity = () => import("./components/Electricity")
    const Monitor = () => import("./components/Monitor")
    const MonitorYSY = () => import("./components/MonitorYSY")
    const Events = () => import("./components/Events")
    const Diagram = () => import("./components/Diagram")
    const MenuButton = () => import("../components/menuButton/menuButton.vue")
    const SitElectricity = () => import("./components/SiteElectricity")
    const PowerGeneration = () => import("./components/PowerGeneration")
    const Soc = () => import("./components/Soc")
    const Environmental = () => import("./components/Environmental")
    const ViewDiagram = () => import("./components/ViewDiagram")

import { getTodayYesTime } from '../utils/common'


    import {
        config
    } from '../config'
    import {
        GetAlarmList,
    } from "../components/Request";
    import DateDiff from "../components/DateDiff"

    export default {
        name: "OverView",
        components: {
            ParkOverView,
            Transformer,
            Power,
            Electricity,
            Monitor,
            Events,
            MenuButton,
            Diagram,
            SitElectricity,
            PowerGeneration,
            Soc,
            Environmental,
            ViewDiagram,
            MonitorYSY
        },
        data() {
            return {
                // 底部导航菜单
                menu: -1,

                // 安防类型
                currentType: 0,
                // 安防设备
                currentDetails: 0,

                alarmId: 0,

                // 顶部报警事件
                alarmState: false,
                alarmTime: 'hidden',
                eventsList:[
                    // {
                    //     id:1,
                    //     src:require('@/assets/img/r.png'),
                    //     eloop:'智能控制实验室-1#变压器',
                    //     ename:'高温',
                    //     etime:'12小时前',
                    //     area:'智能控制实验室',
                    //     level:3
                    // }
                ],
                eventsListt:[
                    // {
                    //     id:1,
                    //     src:require('@/assets/img/r.png'),
                    //     eloop:'智能控制实验室-1#变压器',
                    //     ename:'高温',
                    //     etime:'12小时前',
                    //     area:'智能控制实验室',
                    //     level:3
                    // },
                    // {
                    //     id:2,
                    //     src:require('@/assets/img/y.png'),
                    //     eloop:'智慧配电房-2AA1-微机综保',
                    //     ename:'过电压跳闸',
                    //     etime:'1天前',
                    //     area:'智慧配电房',
                    //     level:2

                    // },
                    // {
                    //     id:3,
                    //     src:require('@/assets/img/b.png'),
                    //     eloop:'智慧配电房-1AA3-电源进线',
                    //     ename:'电流过高',
                    //     etime:'3天前',
                    //     area:'智慧配电房',
                    //     level:1

                    // },
                    // {
                    //     id:4,
                    //     src:require('@/assets/img/b.png'),
                    //     eloop:'智能控制实验室-B2动力负荷-母线',
                    //     ename:'温度过高',
                    //     etime:'1周前',
                    //     area:'智能控制实验室',
                    //     level:1
                    // },
                ],

                url: config.gisUrl,
                iframeWin: {},

                timer: null,
                // 显示全屏接线图
                isshowDiagram:false,
            };
        },
        mounted() {
            if(this.$store.state.currentPage == 0){
                this.$store.commit('set_page',1)
            }
            // this.$store.commit('set_showAlarm',false)

            // setTimeout(()=>{
            //     this.alarmState = true
            // },5000)
            
            this.iframeWin = this.$refs.iframeDom.contentWindow;
            window.addEventListener("message", this.handleMessage);
            // this.getAlarmInfo()

            // this.timer = setInterval(() => this.getAlarmInfo(), 1000 * 60)
            this.getalarms()
        },
        beforeDestroy() {
            window.removeEventListener("message", this.handleMessage)
            this.timer && clearInterval(this.timer)
            this.timer && (this.timer = null)
        },
        computed:{
            electricityFlag(){
                return this.$store.state.electricityFlag
            },
            
        },
        watch: {
            alarmTime(n, o) {
                if (n === 'show') {
                    setTimeout(() => {
                        this.alarmTime = 'hidden'
                    }, 1000 * 30)
                }
            },
            alarmState(val){
                if(val == true){
                    setTimeout(() => {
                        this.alarmState = false
                    },5000)
                }
            },
            electricityFlag(val){
                console.log(val);
                if(val == true){
                    this.sendMessage('clearPowerMonitor')
                }
            },
            // 如果正在显示电缆，进入微电网时选择园区 
            "$store.state.currentPage"(page){
                if(page == 3 && this.menu !=2){
                    this.menu = 1
                }
            }
        },
        methods: {
            getAlarmInfo() {
                GetAlarmList({
                    projectId: this.$store.state.projectId,
                    size: 1,
                    page: 1
                }).then(({
                    data
                }) => {
                    let datas = data.data.alarms
                    if (datas.length > 0) {
                        this.alarmState = true
                        if (datas[0].id != this.alarmId) {
                            this.alarmId = datas[0].id
                            this.alarmTime = 'show'
                        }
                        this.alarm.type = ''
                        this.alarm.area = datas[0].area_name
                        this.alarm.text = (datas[0].loop_name || datas[0].device_name) + '-' + datas[0].alarm_type_desc
                        this.alarm.time = DateDiff((new Date(datas[0].start_time)).getTime())
                    } else {
                        this.alarmState = false
                        this.alarmTime = 'hidden'
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            sendMessage(value,site) {
                if(site == 'site'){
                    switch(this.$store.state.currentPage){
                        case 1:
                            this.iframeWin.postMessage({
                                cmd: 'siteAll',
                            }, "*");
                        break;
                        case 2:
                            this.iframeWin.postMessage({
                                cmd: value,
                            }, "*");
                        break;
                        case 3:
                            this.iframeWin.postMessage({
                                cmd: 'siteWeidian',
                            }, "*");
                        break;
                    }
                    
                    
                }else if(site == 'park'){
                    switch(this.$store.state.currentPage){
                        case 1:
                            this.iframeWin.postMessage({
                                cmd: value,
                            }, "*");
                        break;
                        case 2:
                            this.iframeWin.postMessage({
                                cmd: 'parkSiteview',
                            }, "*");
                        break;
                        case 3:
                            this.iframeWin.postMessage({
                                cmd: 'parkWeidianView',
                            }, "*");
                        break;
                    }
                }else{
                    this.iframeWin.postMessage({
                        cmd: value,
                    }, "*");
                }

            },
            showAlarmPosition() {
                this.menu = 0
                this.iframeWin.postMessage({
                        cmd: "showAlarmPosition",
                        value: this.alarm
                    },
                    "*"
                );
            },
            showAlarmPositionBy(value) {
                this.$store.commit('set_electricityFlag',true)
                this.menu = 0
                let alarm = {
                    area:value.area,
                    text:value.eloop,
                    time:value.etime,
                    type:value.ename,
                    level:value.level
                }
                setTimeout(()=>{
                    this.iframeWin.postMessage({
                        cmd: "showAlarmPosition",
                        value: alarm
                    },"*");
                },100)
                
            },
            handleMessage(event) {
                const data = event.data;
                // console.log(data)
                switch (data.cmd) {
                    case "returnData":
                        console.log("得到html数据: " + data.params.data);
                        let val = data.params.data
                        console.log(val);

                        if (val.type == "site") {
                            if (val.id == -1) {
                                this.$message({
                                    message: "此站点暂无监控",
                                    center: true,
                                });
                            } else if (val.id != -1) {
                                this.$router.push({
                                    path: "/site/" + val.id
                                });
                            }
                        } else if (val.type == "pv") {
                            this.$router.push({
                                path: "/pv/" + val.id
                            });
                        }
                        else if (val.type == "container") {
                            this.$router.push({
                                path: "/container/" + val.id
                            });
                        }else if (val.type == "monitor") {
                            this.currentType = 0;
                            this.currentDetails = val.id;
                        }
                        break;
                        //会一直触发
                        // case "loadEnd":
                        //     // setTimeout(() => {
                        //     //     this.alarmTime = 'show'
                        //     // }, 3000)
                        //     console.log('我来了啊');
                        //     break;
                    case "parkOverview":
                        setTimeout(()=>{
                            if(this.menu == -1){
                                this.menu = 1
                                console.log('显示园区概况');
                            }else{
                                this.menu = -1
                                this.menu = 1
                            }
                        },3000)
                        break;
                    case "3Dstart":
                        setTimeout(()=>{
                            if(this.menu == -1){
                                this.menu = 1
                                console.log('显示园区概况');
                            }else{
                                this.menu = -1
                                this.menu = 1
                            }
                        },3000)
                        break;
                }
            },
            showDiagram(flag){
                this.isshowDiagram = flag
            },
            Diagram(){
                // if(this.menu !=4 ){
                    this.menu = 4
                // }
            },
            Diagram1(){
                if(this.menu == 4){
                    this.menu = -1
                }
            },
            // 园区点击分布按钮
            showElectricity(flag){
                this.menu = -1
                if(flag){
                    this.sendMessage('clearPowerMonitor')

                }else{
                    this.sendMessage('powerMonitor')

                }
            },
            async getalarms(){
                let time = getTodayYesTime()
                try{
                    let data ={
                        start:time.today.replace(/-/g,'/'),
                        end:time.today.replace(/-/g,'/'),
                        projectId:this.$store.state.projectId
                    }
                    let res = await this.$http.alarmEvent(data)
                    console.log(res);
                    let arr = res.data.data.details.map(item =>{
                        return item = {
                            id:item.id,
                            eloop:item.device_name,
                            ename:item.event_name,
                            etime:DateDiff((new Date(item.start_time)).getTime()),
                            area:item.area_name ,
                            level:item.alarm_degree_name == '通知'?1: item.alarm_degree_name == '隐患'?2:3,
                            src:item.alarm_degree_name == '通知'?require('@/assets/img/b.png'): item.alarm_degree_name == '隐患'?require('@/assets/img/y.png'):require('@/assets/img/r.png'),
                        }
                    })
                    this.eventsListt = arr
                    this.$store.commit('setAlarmNum', arr.length)
                }catch(err){
                    console.log(err);
                }
            }
        },
    };
</script>

<style lang="less" scoped>
    .home {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    .menuButtons{
        width: 10vw;
        height: 7vh;
        position: fixed;
        top: 6.8vh;
        left: 22.5vw;
        display: flex;
        flex-direction: row;
    }

    .posAlarm{
        width: 20.8vw;
        position: fixed;
        top: 8vh;
        border-radius: 4px;
        right: 22vw;
        background: linear-gradient(0deg, rgba(0, 33, 59, 0.8) 0%, rgba(3, 13, 24, 0.8) 100%);
        box-shadow: 
            0 0 16rem 0 #FF5555, 
            0 0 16rem 0 #FF5555;
        padding: 0 5rem;
        .alarmEvents{
            width: 100%;
            padding: 0 15rem;
            max-height: 92vh;
            overflow-x:hidden ;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgba(255, 255, 255, 0.7);
                border-radius: 2rem;
            }
            .alarmEvent{
                height: 7.87vh;
                width: 95%;
                .atop{
                    padding-top: 1.4vh;
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    position: relative;
                    .img{
                        width: 2.6vh;
                        height: 2.6vh;
                        vertical-align: middle;
                        margin-top: 0.4vh;
                        display: inline-block;
                        background: url('../assets/img/r.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .eventName{
                        display: inline-block;
                        text-shadow: 
                        0 0 1vh  #de5962,
                        0 0 2vh  #de5962,
                        0 0 3vh  #de5962;
                    }
                    span{
                        position: absolute;
                        right: 0;
                        top: 2vh;
                        font-size: 14rem;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                    }
                    img:nth-of-type(1){
                        width: 16rem;
                        height: 16rem;
                        position: absolute;
                        top: 2.1vh;
                        right: -2.7vh;
                    }
                }
                .abottom{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    padding-left: 1.3vw;
                    padding-top: 0.2vh;
                    position: relative;
                    .con{
                        width: 14vw; 
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    img{
                        width: 0.7vw;
                        height: 1.7vh;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
                
            }
            
        }
    }
    .yellowAlarm{
        box-shadow: 
            0 0 16rem 0 #F5AA00, 
            0 0 16rem 0 #F5AA00;  
            .alarmEvents{
                .alarmEvent{
                    .atop{
                        .img{
                            background: url('../assets/img/y.png') no-repeat;
                        }
                        .eventName{  
                            text-shadow: 
                                0 0 1vh  #F5AA00,
                                0 0 2vh  #F5AA00,
                                0 0 3vh  #F5AA00;
                        }
                    }
                }
            }
            
    }
    .blueAlarm{
        box-shadow: 
            0 0 16rem 0 #0D94FF, 
            0 0 16rem 0 #0D94FF;
            .alarmEvents{
                .alarmEvent{
                    .atop{
                        .img{
                            background: url('../assets/img/b.png') no-repeat;
                        }
                        .eventName{  
                            text-shadow: 
                                0 0 1vh  #0D94FF,
                                0 0 2vh  #0D94FF,
                                0 0 3vh  #0D94FF;
                        }
                    }
                }
            }
    }

    .alarm-enter,
    .alarm-leave-to {
        top: 0,
    }

    .alarm-enter-active,
    .alarm-leave-active {
        transition: top 1s
    }

    .posAlarms{
        width: 20.8vw;
        position: fixed;
        top: 8vh;
        border-radius: 4px;
        right: 22vw;
        background: linear-gradient(0deg, rgba(0, 33, 59, 0.85) 0%, rgba(3, 13, 24, 0.9) 100%);
        padding: 0 5rem;
        .alarmEventss{
            width: 100%;
            padding: 0 15rem;
            max-height: 92vh;
            overflow-x:hidden ;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgba(255, 255, 255, 0.7);
                border-radius: 2rem;
            }
            .alarmEvents{
                height: 7.87vh;
                width: 100%;
                border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                .atops{
                    padding-top: 1.4vh;
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    position: relative;
                    img{
                        width: 2.6vh;
                        height: 2.6vh;
                        vertical-align: middle;
                    }
                    span{
                        position: absolute;
                        right: 0;
                        top: 2vh;
                        font-size: 14rem;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.7);
                    }
                }
                .abottoms{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    padding-left: 1.7vw;
                    padding-top: 0.2vh;
                    position: relative;
                    .cons{
                        width: 14vw; 
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    img{
                        width: 0.7vw;
                        height: 1.7vh;
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
            }

            .noneEvent{
                height: 3vh;
                line-height: 3vh;
                font-size: 16rem;
                text-align: center;
                color: #FFFFFF;
            }
        }
    }
</style>